import { CommonModule } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  signal,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { debounceTime, distinctUntilChanged, lastValueFrom } from "rxjs";
import { AuthService } from "src/app/pages/auth";
import { AddressService } from "src/app/services/api/address.service";
import { Address } from "src/app/services/model/address.model";
import { ToastService } from "src/app/services/toast-service/toast.service";
import { SharedModule } from "src/shared/shared.module";
import { LabelMode } from "src/utils/label-mode.enum";
import { SetError } from "src/utils/set-error.validator";
import { FormComponent } from "./form/form.component";

@Component({
  selector: "app-address-form",
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    FormComponent
  ],
  templateUrl: "./address-form.component.html",
  styleUrl: "./address-form.component.scss",
})
export class AddressFormComponent {
  #fb = inject(FormBuilder);
  #cdr = inject(ChangeDetectorRef);
  #authService = inject(AuthService);
  #addressService = inject(AddressService);
  #toastService = inject(ToastService);

  currentUser = this.#authService.currentUser()?.user;
  userAddress = this.#authService.userAddress;

  form: FormGroup;
  LabelMode = LabelMode;
  error: any;
  isLoading = signal<boolean>(false);

  @Input() set data(value: Address | null) {
    if (!this.form) {
      this.buildForm();
    }
    if (value) {
      this.isLoading.update(() => true);
      this.patchForm(value);
    }
  }
  @Output() closeForm = new EventEmitter();

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.form = this.#fb.group({
      id: [null],
      user_id: [this.currentUser?.id],
      name: [null, Validators.required],
      address: [null, Validators.required],
      province_id: [null, Validators.required],
      district_id: [null, Validators.required],
      sub_district_id: [null, Validators.required],
      post_code: [null, Validators.required],
    });
    this.form
      .get("province_id")
      ?.valueChanges.pipe(debounceTime(100), distinctUntilChanged())
      .subscribe((val) => {
        this.form.patchValue({ district_id: null });
      });
    this.form
      .get("district_id")
      ?.valueChanges.pipe(debounceTime(100), distinctUntilChanged())
      .subscribe((val) => {
        if (!val) {
          this.form.patchValue({ sub_district_id: null });
        }
      });
    this.form
      .get("sub_district_id")
      ?.valueChanges.pipe(debounceTime(100), distinctUntilChanged())
      .subscribe(async (val) => {
        if (val) {
          const sub_dist = await lastValueFrom(
            this.#addressService.getSubDistrict(val),
          );
          this.form.patchValue({ post_code: sub_dist.post_code });
        } else {
          this.form.patchValue({ post_code: null });
        }
      });

  }

  patchForm(value: Address) {
    setTimeout(() => {
      this.form.patchValue(
        {
          ...value,
          province_id: value.province?.id,
          district_id: value.district?.id,
          sub_district_id: value.sub_district_id,
          post_code: value.sub_district?.post_code,
        },
        { emitEvent: false },
      );
      this.isLoading.update(() => false);
      this.#cdr.detectChanges();
    }, 500);
  }

  async submit() {
    this.error = {};
    console.log('form', this.form.value);

    if (this.form.invalid) {
      this.error = SetError(this.form);
      return;
    }
    let payload = this.form.getRawValue();
    const isUpdate = payload.id !== null;

    try {
      const submitService = !isUpdate
        ? this.#addressService.createAddress(payload)
        : this.#addressService.updateAddress(payload.id, payload);
      const newAddress = await lastValueFrom(submitService);
      this.#toastService.toastSuccess("บันทึกข้อมูลสำเร็จ");
      this.onCloseForm();
    } catch (error: any) {
      this.#toastService.toastError("เกิดข้อผิดพลาด: " + error.error.errors);
    }
  }
  // async update() {
  //   this.error = {};
  //   if (this.form.invalid) {
  //     this.error = SetError(this.form);
  //     return;
  //   }
  //   let payload = this.form.getRawValue();
  //   try {
  //     const newAddress = await lastValueFrom(
  //       this.#addressService.updateAddress(payload.id,payload)
  //     );
  //     this.#toastService.toastSuccess("บันทึกข้อมูลสำเร็จ");
  //     this.onCloseForm();
  //   } catch (error: any) {
  //     this.#toastService.toastError("เกิดข้อผิดพลาด: " + error.error.errors);
  //   }
  // }

  onCloseForm() {
    this.closeForm.emit(true);
  }
}
